import ClickData from "./clickdata";
import DisplayChannel from "./channeldisplay";
import {ParsedUrlParams} from "./urlparams";
import { Channel, ChannelGroupingResult, ChannelType, MaybeChannelGroupingResult } from "./channelgrouping";


export default class PaidChannel {

    public static is(params: ParsedUrlParams) : MaybeChannelGroupingResult
    {
        const data = ClickData.parse(params);
        if (data.id.length || data.platform.length) {
            if (DisplayChannel.is(params)) {
                // Display, not Paid Search
                return null;
            }
            return new ChannelGroupingResult(Channel.PaidSearch, ChannelType.Search);
        }
        return null;
    }

}
